/**
 * ReportsHarvestInspectionsTableRowLink
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../../../../../services/router/actions';

// Selectors
import { makeSelectIsActive } from './selectors';

interface Props {
    eventId?: number;
    children: React.Node;
    updateQueryString: Function;
    isActive: boolean;
}

export class ReportsHarvestInspectionsTableRowLink extends React.PureComponent<Props> {
    handleClick = () => {
        const { eventId, isActive } = this.props;

        this.props.updateQueryString({
            selectedEvent: isActive ? undefined : eventId,
            people_page: undefined
        });
    };

    render() {
        const { children, isActive } = this.props;
        return (
            <Table.Row active={isActive} onClick={this.handleClick}>
                {children}
            </Table.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isActive: makeSelectIsActive()
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(ReportsHarvestInspectionsTableRowLink);
